export const BASE_PATH = {
    ERROR: '/error',
    WELCOME: '/welcome',
    USER_PROFILE: '/user-profile',
} as const;
